import { Texto } from '@gravitate-js/excalibrr'
import { Form, InputNumber } from 'antd'
import React from 'react'

export function CurrencyInput({ editable, name, message, initialValue, width, required, formattedCurrency }) {
  if (!editable)
    return (
      <Texto className='ml-1'>
        {formattedCurrency}
        {initialValue}
      </Texto>
    )
  return (
    <Form.Item name={name} noStyle rules={[{ required, message }]}>
      <InputNumber style={{ width }} />
    </Form.Item>
  )
}
